import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import SvgSelector from '../../../Shared/SvgSelector';
import { BREAKPOINTS, COLORS } from '../../../../styles/variables';
import { H2, P1, P2 } from '../../../../styles/textTags';

const DropdownItem = ({ data, dropdown = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <DropdownItemWr>
      <DropdownTitleBlock
        onClick={() => setIsOpen((state) => !state)}
        $isOpen={isOpen}
        $dropdown={dropdown}
      >
        <H2>{data.Name}</H2>
        {dropdown ? <SvgSelector svg='dropdownArrow' /> : <P1>{data.Text}</P1>}
      </DropdownTitleBlock>
      {dropdown && (
        <DropdownContent
          ref={contentRef}
          $isOpen={isOpen}
          $height={contentRef.current?.scrollHeight || 0}
        >
          <P2>{data.Text}</P2>
        </DropdownContent>
      )}
    </DropdownItemWr>
  );
};

const DropdownItemWr = styled.div``;

const DropdownTitleBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  ${H2} {
    text-align: start;
    align-self: center;
  }
  cursor: ${({ $dropdown }) => ($dropdown ? 'pointer' : 'auto')};
  margin-bottom: 16px;

  ${P1} {
    font-size: 24px;
    font-weight: 400;
    justify-self: right;
    align-self: center;
    text-align: end;
  }

  svg {
    width: 40px;
    height: 40px;
    transform: rotate(${({ $isOpen }) => ($isOpen ? '-180deg' : '0deg')});
    transition: transform 0.2s;
    justify-self: right;
    circle {
      fill: ${({ $isOpen }) => ($isOpen ? COLORS.orange : COLORS.white)};
      stroke: ${({ $isOpen }) => ($isOpen ? COLORS.orange : COLORS.brown)};
      transition: 0.2s;
    }

    path {
      fill: ${({ $isOpen }) => ($isOpen ? COLORS.white : COLORS.brown)};
      transition: 0.2s;
    }
  }

  @media ${BREAKPOINTS.laptop} {
    margin-bottom: 1.11vw;
    gap: 1.39vw;
    ${P1} {
      font-size: 1.67vw;
    }

    svg {
      width: 2.78vw;
      height: 2.78vw;
    }
  }

  @media ${BREAKPOINTS.mobile} {
    margin-bottom: 2.5vw;
    gap: 3vw;

    ${P1} {
      font-size: 3.33vw;
    }

    svg {
      width: 6.67vw;
      height: 6.67vw;
    }
  }
`;

const DropdownContent = styled.div`
  background-color: ${COLORS.lightGray};
  overflow: hidden;
  white-space: pre-wrap;
  max-height: ${({ $isOpen, $height }) => ($isOpen ? `${$height + 50}px` : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  border-left: 6px solid ${COLORS.orange};
  padding: ${({ $isOpen }) => ($isOpen ? '14px 27px' : '0 27px')};

  @media ${BREAKPOINTS.laptop} {
    border-left: 0.42vw solid ${COLORS.orange};
    padding: ${({ $isOpen }) => ($isOpen ? '0.97vw 1.88vw' : '0 1.88vw')};
  }

  @media ${BREAKPOINTS.mobile} {
    border-left: 1.25vw solid ${COLORS.orange};
  }
`;

export default DropdownItem;
